"use client";

import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "./utils.ts";

/* Root */
function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn("flex flex-col gap-4", className)}
      {...props}
    />
  );
}

/* Tabs List (Container) */
function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-2xl p-1 " +
          "bg-white/10 backdrop-blur-xl border border-white/20 shadow-lg",
        className
      )}
      {...props}
    />
  );
}

/* Trigger (Sekme Butonları) */
function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "inline-flex flex-1 items-center justify-center px-5 py-2 text-sm font-semibold rounded-xl " +
          "transition-all duration-300 ease-out " +
          "text-muted-foreground hover:text-white hover:bg-white/10 " +
          "data-[state=active]:text-white " +
          "data-[state=active]:bg-gradient-to-r " +
          "data-[state=active]:bg-[#A8322D] " +
          "data-[state=active]:via-red-500 " +
          "data-[state=active]:to-blue-500 " +
          "data-[state=active]:shadow-xl " +
          "active:scale-[0.97] " +
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400",
        className
      )}
      {...props}
    />
  );
}

/* Content */
function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn(
        "mt-4 rounded-xl border border-white/10 bg-white/5 p-4 backdrop-blur-md",
        className
      )}
      {...props}
    />
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
